import { Component } from 'react';
import { DeviceEventEmitter } from 'react-native';

import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import throttle from 'lodash/throttle';
import { values } from 'mobx'
import { inject, observer } from 'mobx-react'

import { WS } from '@kikitrade/api-gateway-client';
import pubsub from '@lib/scripts/pubsub';
import JwtToken, { readonlyToken } from '@utils/jwtToken'

import config from '../utils/config';
import helper from '../utils/helper';

let newMarketDataArray = []
let marketItemUpdateTs = new Date().getTime()
let ws;
// let lastWsPushTime = new Date().getTime()
let lastWsOrderBookPushTime = new Date().getTime()
// const jwtToken = ''
let runOnce = true
const wsRoom = {}
const publish = throttle((data) => {
  pubsub.publish('TRADER_ENTRUST_DATA_CHANGE', data);
}, 1500, { trailing: true })

// @inject(rootStore => ({
//   marketStore: rootStore.store.marketStore
// }))

// @observer
class WebsoketKline extends Component {
  websocketListener = (data) => {
    const that = this;
    const { onReady } = that.props

    if (runOnce) {
      onReady && onReady()
      runOnce = false
    }
    // const that = this;
    // console.log('websocket data: ' + JSON.stringify(data))
    switch (data.type) {
      case 'market-new':
        // lastWsPushTime = new Date().getTime();
        // eslint-disable-next-line no-case-declarations
        const findSymbolIndex = findIndex(newMarketDataArray, (item) => {
          return item.symbol === data.data.symbol
        })
        if (findSymbolIndex !== -1) {
          newMarketDataArray[findSymbolIndex] = data.data
        } else {
          newMarketDataArray.push(
            data.data
          )
        }

        if (new Date().getTime() - marketItemUpdateTs > 1000) {
          // 一秒更新一次
          const newMarketSymbols = values(that.props.marketStore.marketSymbols)
          const newMarketData = {}
          newMarketDataArray.forEach((item, index) => {
            const findSymbolIndex1 = findIndex(newMarketSymbols, (item1) => {
              return item.symbol === item1.coinCode
            })

            if (findSymbolIndex1 !== -1) {
              const oldItem = newMarketSymbols[findSymbolIndex1]

              newMarketData.riseAndFall = item.percentage.toString()
              newMarketData.priceLast = item.mid.toString()
              newMarketData.priceLastRise =
                  Number(item.mid) > Number(oldItem.priceLast)
                    ? 1
                    : (
                        Number(item.mid) < Number(oldItem.priceLast) ? -1 : 0
                      )
              newMarketData.volume = item.volume ? (item.volume ?? '').toString() : oldItem.volume
              newMarketData.highPrice = (item.high ?? '').toString()
              newMarketData.lowPrice = (item.low ?? '').toString()
              newMarketData.ask = item.ask
              newMarketData.bid = item.bid
              newMarketData.orderBaseMax = item.orderBaseMax ? item.orderBaseMax : oldItem.orderBaseMax
              newMarketData.orderBaseMin = item.orderBaseMin ? item.orderBaseMin : oldItem.orderBaseMin
              newMarketData.orderQuoteMax = item.orderQuoteMax ? item.orderQuoteMax : oldItem.orderQuoteMax
              newMarketData.orderQuoteMin = item.orderQuoteMin ? item.orderQuoteMin : oldItem.orderQuoteMin

              // console.log('old marketData:' + JSON.stringify(oldItem))

              newMarketSymbols[findSymbolIndex1] = Object.assign({}, oldItem, newMarketData)
            }
          })
          pubsub.publish('MARKET_SYMBOLS_CHANGE', newMarketSymbols);
          that.props.marketStore.updateMarketSymbol(newMarketSymbols)
          newMarketDataArray = []
          marketItemUpdateTs = new Date().getTime()
        }

        break;
      case 'orderbook':
        lastWsOrderBookPushTime = new Date().getTime();
        // console.log('websocket orderbook data: ' + JSON.stringify(data))
        DeviceEventEmitter.emit('AsksAndBidsData', data.data)
        break;
      case 'order':
        publish(data?.data || data)
        break;
    }
  }

  componentDidMount () {
    try {
      const that = this;
      const { onReady } = that.props
      if (ws) return onReady && onReady()
      const deviceId = helper.createUUID()
      const WSConfig = {
        url: config.websocket.host,
        authType: 'appCode',
        appCode: config.websocket.appCode,
        stage: config.websocket.stage,
        registerPath: '/api/register',
        unregisterPath: '/api/unregister'
      }
      ws = new WS(WSConfig);
      ws.register(
        that.websocketListener,
        deviceId,
        {
          room: 'marketData',
          value:
          JSON.stringify({
            jwtToken: JwtToken.getToken() === readonlyToken ? '' : JwtToken.getToken()
          })
        }
      );

      this.setIntervalOne = setInterval(() => {
        try {
          ws.send('POST', '/api/alive', 'COMMON');
        } catch (e) {
          // ignore
        }
      }, 5 * 1000);

      this.setIntervalTwo = setInterval(() => {
        const now = new Date().getTime();
        if (
          now - lastWsOrderBookPushTime > 1000 * 6 && !isEmpty(wsRoom)
        ) {
          try {
            setTimeout(() => {
              Object.keys(wsRoom).forEach((key) => {
                console.log('wsRoom orderbook' + key)
                ws?.send('POST', '/api/room', 'COMMON', wsRoom[key]);
              })
            }, 1000)
          } catch (e) {
          }
        }
      }, 7 * 1000);

      this.subscription = DeviceEventEmitter.addListener(
        'sendWsData',
        function (eventData) {
          try {
            console.log('sendWsData' + JSON.stringify(eventData))
            ws.send('POST', '/api/room', 'COMMON', eventData);
            wsRoom[eventData.room] = eventData
          } catch (e) {
            // ignore
            console.log(e)
          }
        }
      )
    } catch (e) {
      console.log(e)
    }
  }

  componentWillUnmount = () => {
    if (ws) {
      try {
        ws.autoConnect = false;
        ws.ws.close();
        ws = null;
      } catch (e) {
        // ignore
      }
    }
    clearInterval(this.setIntervalOne)
    clearInterval(this.setIntervalTwo)
  };

  render () {
    return null
  }
}

export default inject(rootStore => ({
  marketStore: rootStore.store.marketStore
}))(observer(WebsoketKline));
